import { combineReducers } from "redux";
import authReducer from "./authReducer";
import siteReducer from "./siteReducer";
import locationReducer from "./locationReducer";
import sellReducer from "./sellReducer";
import storeReducer from "./storeReducer";

const rootReducers = combineReducers({
    auth: authReducer,
    site: siteReducer,
    location: locationReducer,

    // Dashboard Reducers
    stores: storeReducer,
    sell: sellReducer,
});

export default rootReducers;
